import { memo, type ReactNode } from 'react';

import { Tooltip } from '@air/primitive-tooltip';

import { WorkspaceAgentPanelImage } from '~/components/v2/components/workspace/workspace-agent-panel/components/shared/WorkspaceAgentPanelImage';
import { workspaceAgentPanelPill } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentPanelPillChrome';

export type WorkspaceAgentPanelPillProps = {
  action?: ReactNode;
  'data-testid': string;
  label: string;
  thumbnailUrl: string | null;
};

/**
 * A chip that only reports. The onboarding answer chips name something the run already decided, so
 * there is nothing to open. Shares the history-pill chrome with the composer's mentions.
 */
export const WorkspaceAgentPanelPill = memo(
  ({ action, 'data-testid': testId, label, thumbnailUrl }: WorkspaceAgentPanelPillProps) => (
    <span
      className={workspaceAgentPanelPill({ hasLeadingThumbnail: Boolean(thumbnailUrl), surface: 'history' })}
      data-testid={testId}
    >
      {thumbnailUrl ? (
        <WorkspaceAgentPanelImage alt="" className="size-5 shrink-0 object-cover" src={thumbnailUrl} />
      ) : null}
      <Tooltip label={label}>
        <button className="min-w-0 truncate bg-transparent p-0 text-left font-inherit text-inherit" type="button">
          {label}
        </button>
      </Tooltip>
      {action}
    </span>
  ),
);

WorkspaceAgentPanelPill.displayName = 'WorkspaceAgentPanelPill';
